import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable, throwError } from 'rxjs';
import { map, debounceTime, catchError } from 'rxjs/operators';
import { InstituicaoGestora } from '../models/instituicao-gestora.model';
import { Pagination } from '@app/shared/model';
@Injectable({
  providedIn: 'root'
})
export class InstituicaoGestoraService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) { }

  // List all instituicoes de ensino
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: InstituicaoGestora[] }>(`${this.path}/getAllInstituicaoGestora`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      // debounceTime(500),
      map(response => response)
    );
  }

  // Get all reprentants of instiuicoes gestoras
  public getRepresentantes(id: string, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.apiService.get<{ data: any[] }>(
      `${this.path}/getAllRepresentacaoInstituicaoGestora?id=${id}&page=${page}&pageSize=${pageSize}`
    );
  }

  // Get instituicao de ensino by ID
  public show(id: string): Observable<InstituicaoGestora> {
    return this.apiService.get<{ data: InstituicaoGestora }>(`${this.path}/getInstituicaoGestoraById/${id}`).pipe(
      map(response => response.data as InstituicaoGestora)
    );
  }

  // Create new instituicao Gestora
  /*public store(instituicaoGestora: InstituicaoGestora): Observable<any> {
    return this.apiService
      .post<{ object: InstituicaoGestora }>(`${this.path}/AddInstituicaoGestora`, instituicaoGestora)
      .pipe(
        map((response) => response as any)
      );
  }*/

  public store(data: FormData): Observable<any> {
    return this.apiService.post<any>(
      `${this.path}/AddInstituicaoGestora`,
      data,
      {},  // ou `undefined` se seu ApiService não exigir esse parâmetro
    );
  }

  // Update existing instituicao Gestora
  public update(formData: FormData, id: string): Observable<any> {
    return this.apiService.put(`${this.path}/UpdateInstituicaoGestora`, formData)
  }

  // Toggle status of instituicao Gestora
  public toggleStatus(id: string): Observable<InstituicaoGestora> {
    return this.apiService
      .patch<{ object: InstituicaoGestora }>(`${this.path}/ToogleInstituicaoGestoraStatus/${id}`, {})
      .pipe(
        map((response) => response.object as InstituicaoGestora)
      );
  }

  // Delete existing instituicao Gestora
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteInstituicaoGestoraById/${id}`);
  }

  // Get Photo instituicao Gestora
  getFotoInstituicaoGestoraById(id: number): Observable<Blob> {
    return this.apiService.get(`${this.path}/GetInstituicaoGestoraLogotipoById/${id}`,
      new HttpParams(),
      false,
      'blob',
    );
  }
  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('Ocorreu um erro:', error);
    return throwError(() => new Error('Não foi possível carregar a imagem.'));
  }
}
